export default __webpack_public_path__ + "ed19a746aedee8944265ea26e4350e69.png";